/**
 * Create a cookie in order to prevent duplicate submission of data to Analytics
 * Stores the subscription value in the cookie in order to track that revenue
 */
const addCookie = cookieName => {
	document.cookie = `${cookieName}=true`;
	// console.log(`Added cookie: ${cookieName}`);
};

const editCookie = (cookieName, cookieValue) => {
	document.cookie = `${cookieName}=${cookieValue}`;
	// console.log(`Edited cookie: ${cookieName}=${cookieValue}`);
};

const removeCookie = cookieName => {
	document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

const hasCookie = cookieName => {
	if (
		document.cookie.split(";")?.filter(function(item) {
			return item.trim().indexOf(cookieName) === 0;
		}).length
	) {
		return true;
	}
	return false;
};

const getCookie = cookieName => {
	const cookieKey = `${cookieName}=`;
	const cookieArray = document.cookie.split(';');
	for (let cookie of cookieArray) {
	  	while (cookie.charAt(0) == ' ') {
			cookie = cookie.substring(1, cookie.length);
		}
		if (cookie.indexOf(cookieKey) == 0) {
			return cookie.substring(cookieKey.length, cookie.length);
		}
	}
}

export {
	addCookie,
	editCookie,
	removeCookie,
	hasCookie,
	getCookie
}
